import React from 'react';
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { RegularButton as Button, RegularButtonProps } from 'fronton-react';
import { useTranslation } from 'react-i18next';

const FooterButton = (props: RegularButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      size={props.size}
      variant="primary"
      label={t('calculator.dimensions.footerButton')}
      type="submit"
      form="dimensions-form"
      {...(props.wide ? { wide: props.wide } : {})}>
      {t('calculator.dimensions.footerButton')}
    </Button>
  );
};

export const DimentionsFooter = () => {
  const { tablet, mobile } = useBreakpoints() ?? {};
  return tablet || mobile ? <FooterButton size="l" wide /> : <FooterButton size="l" />;
};
